import { batch } from 'react-redux';
import * as analytics from '../util/analytics';

const UPDATE_TITLE = 'UPDATE_TITLE';
const UPDATE_DEK = 'UPDATE_DEK';
const UPDATE_SUBDEK = 'UPDATE_SUBDEK';
const UPDATE_NOTE = 'UPDATE_NOTE';
const UPDATE_SOURCE = 'UPDATE_SOURCE';
const UPDATE_DATE = 'UPDATE_DATE';
const UPDATE_XAXISTITLE = 'UPDATE_XAXISTITLE';
const UPDATE_YAXISTITLE = 'UPDATE_YAXISTITLE ';
const UPDATE_SLUG = 'UPDATE_SLUG';
const UPDATE_SUBDEKPROMO = 'UPDATE_SUBDEKPROMO';
const UPDATE_NOTEPROMO = 'UPDATE_NOTEPROMO';
const UPDATE_SOURCEPROMO = 'UPDATE_SOURCEPROMO';
const UPDATE_CHART_FONT = 'UPDATE_CHART_FONT';
const UPDATE_ALT_TEXT = 'UPDATE_ALT_TEXT';

function updateTitle(payload, enabled) {
  return { type: UPDATE_TITLE, payload, enabled };
}

function updateDek(payload, enabled) {
  return { type: UPDATE_DEK, payload, enabled };
}

function updateSubdek(payload, enabled) {
  return { type: UPDATE_SUBDEK, payload, enabled };
}

function updateNote(payload, enabled) {
  return { type: UPDATE_NOTE, payload, enabled };
}

function updateSource(payload, enabled) {
  return { type: UPDATE_SOURCE, payload, enabled };
}

function updateDate(payload, enabled) {
  return { type: UPDATE_DATE, payload, enabled };
}

function updateXaxisTitle(payload, enabled) {
  return { type: UPDATE_XAXISTITLE, payload, enabled };
}

function updateYaxisTitle(payload, enabled) {
  return { type: UPDATE_YAXISTITLE, payload, enabled };
}

function updateSlug(payload) {
  return { type: UPDATE_SLUG, payload };
}

function updateSubdekPromo(payload, enabled) {
  return { type: UPDATE_SUBDEKPROMO, payload, enabled };
}

function updateSourcePromo(payload, enabled) {
  return { type: UPDATE_SOURCEPROMO, payload, enabled };
}

function updateNotePromo(payload, enabled) {
  return { type: UPDATE_NOTEPROMO, payload, enabled };
}

function updatePromoFields(subdekPromo, notePromo, sourcePromo) {
  batch(() => {
    updateSubdekPromo(subdekPromo.text, subdekPromo.enabled);
    updateSourcePromo(notePromo.text, notePromo.enabled);
    updateNotePromo(sourcePromo.text, sourcePromo.enabled);
  });
}

function updateChartFont(payload) {
  return { type: UPDATE_CHART_FONT, payload };
}

function updateAltText(payload) {
  analytics.track('event', 'Text', 'Update Alt text', payload.text);
  return { type: UPDATE_ALT_TEXT, payload };
}

export {
  UPDATE_TITLE,
  UPDATE_DEK,
  UPDATE_SUBDEK,
  UPDATE_NOTE,
  UPDATE_SOURCE,
  UPDATE_DATE,
  UPDATE_XAXISTITLE,
  UPDATE_YAXISTITLE,
  UPDATE_SLUG,
  UPDATE_SUBDEKPROMO,
  UPDATE_NOTEPROMO,
  UPDATE_SOURCEPROMO,
  UPDATE_CHART_FONT,
  UPDATE_ALT_TEXT,
  updateTitle,
  updateDek,
  updateSubdek,
  updateNote,
  updateSource,
  updateDate,
  updateXaxisTitle,
  updateYaxisTitle,
  updateSlug,
  updateSubdekPromo,
  updateSourcePromo,
  updateNotePromo,
  updatePromoFields,
  updateChartFont,
  updateAltText,
};
